var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('game-items-list',{attrs:{"game-item-variant":"models"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('models.list'))+" ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }